var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDaoArrowRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Arrow Right",
    clipPath: "url(#clip0_3584_56686)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M8.995 6.08712C8.97711 6.2196 8.92033 6.34375 8.83321 6.4404L4.05401 11.7732C3.94822 11.9073 3.79498 11.9898 3.63085 11.999C3.46595 12.009 3.30571 11.9456 3.18591 11.824C3.0669 11.7032 3 11.534 3 11.3582C3.00078 11.1816 3.06923 11.0132 3.18902 10.8933L7.57612 6.00034L3.18902 1.10742C3.06923 0.986602 3.00078 0.818281 3 0.642471C3 0.465824 3.0669 0.297505 3.18591 0.175854C3.3057 0.0550327 3.46593 -0.00829291 3.63085 0.000873045C3.79498 0.010872 3.94823 0.0925304 4.05401 0.227515L8.83321 5.56028C8.95922 5.70026 9.01834 5.89358 8.995 6.0869V6.08712Z",
    fill: "#0A0A0A"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3584_56686"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDaoArrowRight);
export default __webpack_public_path__ + "static/media/dao_arrow_right.296f460da3bedd332777aae217f6000a.svg";
export { ForwardRef as ReactComponent };